import * as React from 'react';
import { DefaultButton, PrimaryButton } from '@fluentui/react';
import { TextField } from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useEffect, useState} from "react";
import {Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";

function AddAgreementCategory(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [type, setType] = useState('');

    const _submit = (e) => {
        e.preventDefault();
        const data = {name: name, type: type};
        fetch(`/api/agreement_category`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddAgreementCategory'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        setName('');
    }, [props.add])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Kategorię Umowy"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddAgreementCategory'>
                <TextField required autoFocus label='Nazwa' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <TextField required autoFocus label='Typ' value={type} onChange={(e) => setType(e.target.value || '')}/>
            </form>
        </Panel>
    )
}

export default AddAgreementCategory;